<template lang="pug">
  .container.grid-xl
    page-title(title="Transferências" icon="fas fa-exchange-alt" subtitle="Todas as transferências realizadas na Iugu")
    list-manager(:loading="loading" :error="error" :paginated-list="list" @fetch-data="fetchData")
      table.table(v-if="list")
        thead
          tr
            th.text-center #
            th Afiliado
            th Data / Hora
            th.text-center Balanço
            th.text-right Valor
        tbody
          tr(v-for="transfer in list.rows" :key="transfer.id")
            td.text-center {{ `#${transfer.id}` }}
            td
              router-link(:to="{ name: 'filiations.show', params: { id: transfer.filiationId } }") {{ transfer.filiation.person.fullName }}
            td {{ transfer.createdAt | toDate('DD/MM/YYYY HH:mm') }}
            td.text-center
              router-link(v-if="transfer.filiationBalanceId" :to="{ name: 'filiations.balances.list', query: { q: { id: transfer.filiationBalanceId } } }") 
                | {{ `#${transfer.filiationBalanceId}` }}
              div(v-else) -
            td.text-right
              .text-bold.text-success {{ transfer.amount | currency('R$ ') }}
</template>

<script>
import transfers from '@/services/transfers'

export default {
  data() {
    return {
      list: null,
      loading: false,
      error: null,
    }
  },
  methods: {
    async fetchData(params = {}) {
      try {
        this.loading = true
        const { data } = await transfers.list(params)
        this.list = data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    const params = this.$route.query
    this.fetchData(params)
  },
}
</script>
